module.exports = __webpack_public_path__ + "static/media/feat-bite-hero.5a6ec743.jpg";